export const READ_ACTIVITIES = 'READ_ACTIVITIES';
export const CREATE_ACTIVITY = 'CREATE_ACTIVITY';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';

// eslint-disable-next-line no-shadow
export const readActivitiesAction = (activities, queryId = 'default') => ({
  type: READ_ACTIVITIES,
  payload: {
    activities,
    queryId,
  },
});

export const createActivityAction = (activity, queryId = 'default') => ({
  type: CREATE_ACTIVITY,
  payload: {
    activity,
    queryId,
  },
});

export const updateActivityAction = (activity, queryId = 'default') => ({
  type: UPDATE_ACTIVITY,
  payload: {
    activity,
    queryId,
  },
});

export const deleteActivityAction = (activityId, queryId = 'default') => ({
  type: DELETE_ACTIVITY,
  payload: {
    activityId,
    queryId,
  },
});

const initialActivities = { default: {} };

export function activities(state = initialActivities, action) {
  switch (action.type) {
    case READ_ACTIVITIES: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.activities.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_ACTIVITY:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.activity._id]: action.payload.activity,
        },
      };
    case UPDATE_ACTIVITY: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.activity._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.activity._id]: {
            ...current,
            ...action.payload.activity,
          },
        },
      };
    }
    case DELETE_ACTIVITY: {
      const { activityId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [activityId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
